<template>
  <div class="maintain_container">
    <TopBroadcast v-if="topText" :top-text="topText" :config-obj="configObj" />
    <div class="top_area">
      <div class="top_logo">
        <img src="./images/logo_little.png" alt="" />
      </div>
      <div class="icon_message" v-if="subscribeSwitch" @click="handleMessage">
        <img src="./images/ic_nav_mess.png" alt="" />
        <!-- <div class="meseeage_num">2</div> -->
      </div>

      <div class="sub_box" v-if="subscribeSwitch">
        <div class="sub_text">
          <span v-if="isSubscribe" style="color: #ff5500">已订阅</span>
          <span v-else>消息订阅</span>
        </div>
        <div class="sub_icon" @click="handleSubscribe(1)">
          <img v-if="isSubscribe" src="./images/switch_on.png" alt="" />
          <img v-else src="./images/switch_off.png" alt="" />
        </div>
      </div>

      <WxOpenAppItm v-if="hasAuth" v-on:linkAppMed="linkAppMed"></WxOpenAppItm>
    </div>
    <div class="top_title">
      <div class="title_text">
        <img src="./images/skill_title.png" alt="" />
      </div>
      <div class="title_tips">
        兼容OpenClaw等主流平台，东方财富妙想大模型和专业数据库加持，开箱即用
      </div>
    </div>
    <div v-if="!hasReceive" class="api_key_get_area">
      <div class="api_key_get_title">
        <img class="api_key_get_icon" src="./images/ic_password.png" alt="" />
        <span>API KEY领取：限时免费体验，</span>
        <span class="api_key_get_limit">每日限量5000名</span>
      </div>
      <div class="api_key_get_progress_bar">
        <div
          class="api_key_get_progress_inner"
          :style="{ width: receiveProgress + '%' }"
        ></div>
      </div>
      <div class="api_key_get_btn_wrap" @click="handleReceive">
        <div class="api_key_get_btn">
          <div class="api_key_get_btn_percent">已抢{{ receiveProgress }}%</div>
        </div>
        <div class="pic_qzbox">
          <img src="./images/pic_qz.png" alt="" />
        </div>
        <WxOpenAppItm
          v-if="hasAuth"
          v-on:linkAppMed="linkAppMed"
        ></WxOpenAppItm>
      </div>
    </div>
    <div v-else-if="canCopyAll" class="jc_box">
      <div class="title_box">集成说明</div>
      <div class="sub_box">
        复制以下提示发送给您的OpenClaw或其他AI
        Agent，将自动完成5个skill的安装。<span
          >为了您的账号安全，请不要将您的API KEY发送给他人。</span
        >
      </div>
      <div class="copy_box" @click="copyPromptAndKey">
        <div class="copy_text">
          {{ maskApiKey(copyAllText) }}
        </div>
        <div class="icon_box">
          <img src="./images/ic_copy_index.png" alt="" />
        </div>
      </div>
      <div class="copy_btn" @click="copyPromptAndKey">复制提示词 & Key</div>
    </div>
    <div v-if="hasReceive" class="keys_box_only">
      <div
        class="key_btn"
        @click="linkMyKeys()"
        tracker-eventcode="ckwdkeys_000"
      >
        <div class="ic_key">
          <img class="ic_pwd" src="./images/ic_password.png" alt="" />
        </div>
        <div class="mid_text">
          <div class="text1">我的API KEY管理</div>
          <div class="text2">点击管理API KEY</div>
        </div>

        <div class="ic_arrow">
          <img src="./images/ic_arrow.png" class="ic_arrow" alt="" />
        </div>
      </div>
      <!-- 进阶版 -->
      <div
        class="key_btn key_vip2"
        @click="linkMyKeys(1)"
        v-if="isVip == 'MXSKILLSL1YH'"
        tracker-eventcode="djtcqyjxh_000"
      >
        <div class="ic_key">
          <img class="ic_pwd" src="./images/ic_jf2.png" alt="" />
        </div>
        <div class="mid_text">
          <div class="text1">妙想skills进阶版</div>
          <div class="text2">限时尊享500次调用</div>
        </div>

        <div class="ic_arrow">
          <img src="./images/ic_arrow.png" class="ic_arrow" alt="" />
        </div>
      </div>
      <div
        class="key_btn key_vip"
        @click="linkMyKeys(1)"
        v-else-if="isVip == 'MXSKILLSL2YH'"
        tracker-eventcode="djtcqyjxh_000"
      >
        <div class="ic_key">
          <img class="ic_pwd" src="./images/ic_jf_vip.png" alt="" />
        </div>
        <div class="mid_text">
          <div class="text1" style="color: #fff3df">妙想skills旗舰版</div>
          <div class="text2" style="color: #fff3df; opacity: 0.8">
            限时尊享800次调用
          </div>
        </div>

        <div class="ic_arrow">
          <img src="./images/ic_arrow_vip.png" class="ic_arrow" alt="" />
        </div>
      </div>
      <!-- 普通按钮 -->
      <div
        class="key_btn"
        @click="linkMyKeys(1)"
        tracker-eventcode="djtcqyjxh_000"
        v-else
      >
        <div class="ic_key">
          <img class="ic_pwd" src="./images/ic_jf.png" alt="" />
        </div>
        <div class="mid_text">
          <div class="text1">妙想skills普通版</div>
          <div class="text2">限时享150次调用</div>
        </div>

        <div class="ic_arrow">
          <img src="./images/ic_arrow.png" class="ic_arrow" alt="" />
        </div>

        <div class="key_tag">
          <div>升级更多调用次数</div>
        </div>
      </div>
    </div>
    <SwiperAd
      v-if="swiperArr && swiperArr.length > 0"
      :swiper-arr="swiperArr"
    />
    <div
      class="content_box"
      v-for="(item, index) in introArr"
      :key="index"
      @click="openDetail(item)"
      tracker-eventcode="djckskillxq_000"
    >
      <div class="content_top">
        <div class="left_icon">
          <img :src="item.skillIcon" alt="" />
        </div>
        <div class="mid_title">{{ item.skillName }}</div>
        <div class="right_more">
          详情
          <div class="arrow">
            <img src="./images/arrow.png" alt="" />
          </div>
        </div>
      </div>
      <div class="content_intro">
        {{ item.skillDesc }}
      </div>
      <div class="content_tag">
        <span
          class="tag_item"
          v-for="(item2, index2) in item.featureTags"
          :key="index2"
          >{{ item2 }}</span
        >
      </div>

      <!-- 组合 -->
      <div
        class="combination_btn"
        v-if="item.skillTag == 'mnzh'"
        @click.stop="openCombinationPopup()"
        :tracker-eventcode="combinationName ? 'qhb_000' : 'qbd_000'"
      >
        <div class="combination_left">绑定组合名称：</div>

        <div class="combination_right">
          <div class="combination_name">
            {{ combinationName || "" }}
          </div>
          <div class="text" v-if="combinationName">去换绑</div>
          <div class="text" v-else>去绑定</div>
          <div class="arrow_icon">
            <img src="./images/arrow.png" alt="" />
          </div>
        </div>
      </div>
      <!-- AI社区 -->
      <div
        class="combination_btn"
        v-if="item.skillTag == 'aisq'"
        @click.stop="submitAuthClick"
      >
        <div class="combination_left">授权发帖：</div>

        <div class="combination_right">
          <div class="text" v-if="hasAISQAuth">已授权</div>
          <div class="text" v-else>未授权</div>
          <div class="arrow_icon" v-if="!hasAISQAuth">
            <img src="./images/arrow.png" alt="" />
          </div>
        </div>
      </div>
      <!-- 组合 -->
      <div class="combination_tips" v-if="item.skillTag == 'mnzh'">
        <div class="ic_detail">
          <svg
            width="1024"
            height="1024"
            viewBox="0 0 1024 1024"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M512 96C282.4 96 96 282.4 96 512s186.4 416 416 416 416-186.4 416-416S741.6 96 512 96zm0 768C318 864 160 706 160 512S318 160 512 160s352 158 352 352-158 352-352 352z"
              fill="#ff6600"
            />
            <path
              d="M512 288c-26.4 0-48 21.6-48 48s21.6 48 48 48 48-21.6 48-48-21.6-48-48-48zm32 448h-64V448h64v288z"
              fill="#ff6600"
            />
          </svg>
        </div>
        注：模拟组合skill需绑定模拟组合后使用
      </div>
      <!-- AI社区 -->
      <div class="combination_tips" v-if="item.skillTag == 'aisq'">
        <div class="ic_detail">
          <svg
            width="1024"
            height="1024"
            viewBox="0 0 1024 1024"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M512 96C282.4 96 96 282.4 96 512s186.4 416 416 416 416-186.4 416-416S741.6 96 512 96zm0 768C318 864 160 706 160 512S318 160 512 160s352 158 352 352-158 352-352 352z"
              fill="#ff6600"
            />
            <path
              d="M512 288c-26.4 0-48 21.6-48 48s21.6 48 48 48 48-21.6 48-48-21.6-48-48-48zm32 448h-64V448h64v288z"
              fill="#ff6600"
            />
          </svg>
        </div>
        注：妙想AI社区发帖skill需授权后才可发帖
      </div>

      <WxOpenAppItm v-if="hasAuth" v-on:linkAppMed="linkAppMed"></WxOpenAppItm>
    </div>

    <div class="bottom_tips">更多技能，敬请期待</div>

    <!-- 全平台入口指引 -->
    <PlatformGuide />

    <DisscussBox @callLoginHandle="callLoginHandle"></DisscussBox>

    <div class="bottom_fixed">
      <div
        class="bottom_btn"
        @click="handleViewDoc"
        tracker-eventcode="djckwd_000"
      >
        <div class="icon_book">
          <img src="./images/ic_book.png" alt="" />
        </div>
        查看文档

        <WxOpenAppItm
          v-if="hasAuth"
          v-on:linkAppMed="linkAppMed"
        ></WxOpenAppItm>
      </div>
    </div>

    <SkillDetailPopup
      v-model="detailVisible"
      :item="currentDetailItem"
      :hasAISQAuth="hasAISQAuth"
      @view-doc="handleViewDoc"
      @link-hub="handleLinkHub"
      @auth="detailToAuth"
    />

    <CombinationSelectPopup
      v-model="combinationPopupVisible"
      :list="combinationList"
      :defaultSelectedId="selectedCombinationId"
      @confirm="handleCombinationConfirm"
    />
    <CenterPop
      v-if="ctPopType"
      :ctPopType="ctPopType"
      @handleCenterPop="handleCenterPop"
    ></CenterPop>
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, onMounted, onActivated, ref } from "vue";
import { getActConfigInfo, copyContent } from "@/utils/common";
import fetchData from "@/utils/fetchData";
import {
  appInfo,
  openWebView,
  getLoginInfo,
  performNativeLogin,
  appConfirm,
  openTransWebView,
  callHybridHandle,
} from "@eastmoney/mku";
import CenterPop from "./components/CenterPop.vue";
import PlatformGuide from "./components/PlatformGuide.vue";
import { useMainStore } from "@/pinia/main";
const { setUserInfo, hasAuth } = useMainStore();
import { storeToRefs } from "pinia";
const { haslogin, userObj } = storeToRefs(useMainStore()); // 又读又写的时候使用ref响应式
import { $loading, $toast } from "@/utils/globalUtils";
import copyText from "@/utils/copy";
import router from "@/router";

const SkillDetailPopup = defineAsyncComponent(() =>
  import("./SkillDetailPopup.vue").then(
    (module: any) => module.default || module
  )
);
const TopBroadcast = defineAsyncComponent(() =>
  import("./components/TopBroadcast.vue").then(
    (module: any) => module.default || module
  )
);
const SwiperAd = defineAsyncComponent(() =>
  import("./components/SwiperAd.vue").then(
    (module: any) => module.default || module
  )
);
const DisscussBox = defineAsyncComponent(() =>
  import("./components/DisscussBox.vue").then(
    (module: any) => module.default || module
  )
);
const WxOpenAppItm = defineAsyncComponent(() =>
  import("@/components/WxOpenAppItm.vue").then(
    (module: any) => module.default || module
  )
);
const CombinationSelectPopup = defineAsyncComponent(() =>
  import("./components/CombinationSelectPopup.vue").then(
    (module: any) => module.default || module
  )
);

const hubUrls: any = {
  // 资讯搜索skill hub
  scss: "https://clawhub.ai/QQK000/eastmoney-financial-search",
  // 金融数据skill hub
  cwcs: "https://clawhub.ai/QQK000/eastmoney-financial-data",
  // 智能选股skill hub
  zncg: "https://clawhub.ai/QQK000/eastmoney-select-stock",
};

type SkillItem = {
  skillName: string;
  skillTag: string;
  skillDesc: string;
  skillIcon: string;
  featureTags: string[];
  featurePoints: string[];
};

const introArr = ref<SkillItem[]>([]);
const detailVisible = ref(false);
const currentDetailItem = ref<SkillItem | null>(null);
const hasReceive = ref(false);
const receiveProgress = ref(0);
const combinationPopupVisible = ref(false);

const combinationList = ref([]);
const combinationName = ref("");
const selectedCombinationId = ref("");
const copyAllText = ref("");
const canCopyAll = ref(false);
const isVip = ref("");
const topText = ref("");
const configObj = ref<any>({});
const swiperArr = ref<any>([]);
const isSubscribe = ref(false);
const subscribeSwitch = ref(false);
const hasAISQAuth = ref(false); // 妙想AI社区是否已授权
const ctPopType = ref("");

onMounted(() => {
  initPageData();
  handlePageView("onMounted");
  window.onHybridMethodCallBack = (res: any) => {
    if (res && res["event"] === "onResume") {
      initPageData();
      callLoginHandle(() => {
        handlePageView("onMounted");
      }, true);
    }
  };

  setTimeout(() => {
    getSubscribeStatus();
  }, 500);
});
onActivated(() => {
  console.error("onActivated");
  initPageData();
  callLoginHandle(() => {
    handlePageView("onActivated");
  }, true);
});
const handlePageView = (type: any) => {
  appInfo.inApp(
    () => {
      if (haslogin.value) {
        getKeyList();
        getCombinationList();
        getVipStatus();
        queryAuthMed();
        getSleepStatus();
      } else {
        getReceiveProgress();
      }
    },
    () => {
      // App外
      getReceiveProgress();
    }
  );
};
const getVipStatus = () => {
  const obj = {
    api: "/api/benefit/query/queryEndTime",
    data: {},
    success: (res: any) => {
      if (res && res.status === 0 && res.data && res.data.roleCode) {
        isVip.value = res.data.roleCode;
      } else {
        isVip.value = "";
      }
    },
  };

  fetchData.doPost(obj);
};
const getSleepStatus = () => {
  const obj = {
    api: "/skill/hibernate-status",
    data: {},
    success: (res: any) => {
      if (res && res.status === 0 && res.data) {
        if (res.data.dormant) {
          accountActivate();
        }
        if (res.data.activatedTime) {
          setUserInfo({
            activatedTime: res.data.activatedTime,
          });
        }
      }
    },
  };

  fetchData.doGet(obj);
};
const getKeyList = (callback?: any) => {
  const obj = {
    api: "/apikey/usage",
    data: {
      st: new Date().getTime(),
    },
    success: (res: any) => {
      if (res && res.status === 0 && res.data) {
        let resp = res.data;
        let keyList = resp.keys || [];

        if (keyList && keyList.length > 0) {
          hasReceive.value = true;
          getSkillGather();
        } else {
          callback && callback();
          hasReceive.value = false;
          getReceiveProgress();
        }
      } else {
        callback && callback();
        hasReceive.value = false;
        getReceiveProgress();
      }
      window.pageLoadMed();
    },
    fail: () => {
      callback && callback();
      hasReceive.value = false;
      getReceiveProgress();
    },
  };

  fetchData.doGet(obj);
};
// 获取skill集合
const getSkillGather = () => {
  let obj = {
    api: "/skill/collection",
    data: {
      st: new Date().getTime(),
    },
    success: (res: any) => {
      if (res && res.status === 0 && res.data) {
        let content = (res.data && res.data?.content) || "";
        if (content) {
          canCopyAll.value = true;
          copyAllText.value = content;
        } else {
          canCopyAll.value = false;
          copyAllText.value = "";
        }
      } else {
        canCopyAll.value = false;
        copyAllText.value = "";
      }
    },
    fail: () => {
      canCopyAll.value = false;
      copyAllText.value = "";
    },
  };
  fetchData.doGet(obj);
};
const getCombinationList = () => {
  const obj = {
    api: "/api/mockTrading/account/list",
    data: {},
    success: (res: any) => {
      if (res && res.code === "200") {
        console.log(res.data, "-----");

        if (res.data && res.data.length > 0) {
          let resp = res.data || [];
          let _combinationList = resp.filter((item: any) => {
            return item.isValid;
          });
          combinationList.value = _combinationList;
        } else {
          combinationList.value = [];
        }
      }

      getMyCombination();
    },
  };
  fetchData.doPost(obj);
};
const getMyCombination = () => {
  const obj = {
    api: "/api/mockTrading/account/query",
    data: {},
    success: (res: any) => {
      if (res && res.status === 0 && res.data) {
        combinationName.value = res.data.accountName || "";
        selectedCombinationId.value = res.data.accountId || "";
      } else {
        combinationName.value = "";
        selectedCombinationId.value = "";
      }
    },
    fail: () => {
      combinationName.value = "";
      selectedCombinationId.value = "";
    },
  };
  fetchData.doPost(obj);
};
const handleReceive = () => {
  appInfo.inApp(
    () => {
      // 东财App内
      callLoginHandle(() => {
        getKeyList(() => {
          createMyKeys();
        });
      });
    },
    () => {
      // App外
      window.linkAppMed();
    }
  );
};
const createMyKeys = () => {
  let obj = {
    api: "/apikey/create",
    success: (res: any) => {
      if (res && res.status == 0 && res.data) {
        $toast.show("领取成功", 3000);
        hasReceive.value = true;
        getSkillGather();
      } else {
        $toast.show("领取失败，请稍后重试", 3000);
      }
    },
    fail: () => {
      $toast.show("领取失败，请稍后重试", 3000);
    },
  };
  fetchData.doPost(obj);
};
// 秘钥管理
const linkMyKeys = async (activeTab: number = 0) => {
  console.error("linkMyKeys");
  const targetPath = "/mykeys";
  const targetQuery = { activeTab: String(activeTab) };
  if (
    router.currentRoute.value.path === targetPath &&
    router.currentRoute.value.query.activeTab === targetQuery.activeTab
  ) {
    return;
  }
  try {
    await router.push({
      path: targetPath,
      query: targetQuery,
    });
  } catch (error) {
    window.location.href = `${window.location.origin}/views/finskillshub/mykeys?activeTab=${targetQuery.activeTab}`;
  }
};
const maskApiKey = function (str: any) {
  if (!str) {
    return "";
  }
  return str.replace(/(MX_APIKEY=)(....)(.*?)(....)(\s|$)/, "$1$2****$4$5");
};

const openDetail = (item: SkillItem) => {
  appInfo.inApp(
    () => {
      // 东财App内
      callLoginHandle(() => {
        currentDetailItem.value = item;
        detailVisible.value = true;
      });
    },
    () => {
      // App外
      window.linkAppMed();
    }
  );
};
//--模拟组合相关
const openCombinationPopup = () => {
  appInfo.inApp(
    () => {
      // 东财App内
      if (haslogin.value) {
        getCombinationList();
        combinationPopupVisible.value = true;
      } else {
        callLoginHandle();
      }
    },
    () => {
      // App外
      window.linkAppMed();
    }
  );
};

const handleCombinationConfirm = (item: any) => {
  if (!item) {
    return;
  }
  const obj = {
    api: "/api/mockTrading/account/bind",
    data: {
      accountId: item.id,
      accountName: item.name,
    },
    success: (res: any) => {
      if (res && res.status === 0 && res.data) {
        getCombinationList();
        combinationPopupVisible.value = false;
      } else if (res && res.status === 100102) {
        appConfirm({
          title: "提示", // 标题
          content: res.message,
          confirmButtonText: "前往炒股大赛", // 可选填，内容为空时，则不显示确认按钮
          cancelButtonText: "我知道了", // 可选填，内容为空时，则不显示取消按钮
          confirm: () => {
            // 选填，用户确认的回调
            openTransWebView("https://dl.dfcfs.com/m/nhk8", 1);
          },
          cancel: () => {
            // 选填，用户取消的回调
            console.log("用户点击取消的回调");
          },
        });
      } else {
        $toast.show("绑定失败，请稍后重试", 3000);
      }
    },
    fail: () => {
      $toast.show("绑定失败，请稍后重试", 3000);
    },
  };
  fetchData.doPost(obj);
};

const handleViewDoc = () => {
  // detailVisible.value = false;
  appInfo.inApp(
    () => {
      // 东财App内
      openWebView("https://dl.dfcfs.com/m/vcrh");
    },
    () => {
      // App外
      window.linkAppMed();
    }
  );
};
const handleLinkHub = (item: any) => {
  appInfo.inApp(
    () => {
      // 东财App内
      let url =
        item["clawhubAddress"] ||
        hubUrls[item.skillTag] ||
        "https://clawhub.ai/u/QQK000";
      if (appInfo.isIOS) {
        window.location.href = `eastmoney://page/opensafari?url=${encodeURIComponent(
          url
        )}`;
      } else {
        window.location.href = `dfcft://webh5?isAd=1&url=${encodeURIComponent(
          url
        )}`;
      }
    },
    () => {
      // App外
      window.linkAppMed();
    }
  );
};

/**
 * 跳转承接页
 */
const linkAppMed = () => {
  window.linkAppMed();
};

const initPageData = () => {
  const obj = {
    api: "/skill/list",
    success: (res: any) => {
      if (res && res.status == 0 && res.data) {
        introArr.value = res.data;
      }
    },
    fail: () => {},
  };
  fetchData.doGet(obj);

  getActConfigInfo((configData: any) => {
    console.log(configData, "----configData");
    configObj.value = configData || {};
    if (
      configData &&
      configData["bannerConfig"] &&
      configData["bannerConfig"].length > 0
    ) {
      swiperArr.value = configData["bannerConfig"];
    } else {
      swiperArr.value = [];
    }

    if (
      configData &&
      configData["noticeConfig"] &&
      configData["noticeConfig"][0] &&
      configData["noticeConfig"][0]["content"]
    ) {
      {
        topText.value = configData["noticeConfig"][0]["content"];
      }
    } else {
      topText.value = "";
    }
  });
};
const getReceiveProgress = () => {
  const obj = {
    api: "/skill/claimed-progress",
    data: {
      st: new Date().getTime(),
    },
    success: (res: any) => {
      if (res && res.status == 0 && res.data) {
        let resp = res.data;
        if (resp >= 100) {
          resp = 100;
        }
        receiveProgress.value = resp;
      }

      window.pageLoadMed();
    },
    fail: () => {
      window.pageLoadMed();
    },
  };
  fetchData.doGet(obj);
};

// 复制提示词和key
const copyPromptAndKey = async () => {
  if (!copyAllText.value) {
    $toast.show("当前skill已暂停止使用", 3000);
    return;
  }

  $loading.show();
  const text = copyAllText.value;
  if (!text) {
    $loading.hide();
    return;
  }
  copyContent({
    content: text,
    callback: (isSuccess: any) => {
      if (isSuccess) {
        $loading.hide();
        $toast.show("复制成功", 3000);
      } else {
        $loading.hide();
        $toast.show("复制失败，请长按手动复制", 3000);
      }
    },
  });
};
// 订阅
const handleSubscribe = (openType: any) => {
  appInfo.inApp(
    () => {
      // 东财App内
      if (isSubscribe.value && openType == 1) {
        callHybridHandle({
          moduleName: "Push", // 模块
          methodName: "emUpdateSubscribeStatus", // 方法名
          requestJson: {
            bizCode: "mxskills",
            subscribeStatus: 0, //1-订阅，0-取消订阅
          },
          callback: (res: any) => {
            console.log(res, "----emUpdateSubscribeStatus");
            if (res && res.data && res.data.responseStatus == 1) {
              isSubscribe.value = false;
            }
          },
        });
        return;
      } else {
        callHybridHandle({
          moduleName: "Push", // 模块
          methodName: "emStartSubscribe", // 方法名
          requestJson: {
            bizCode: "mxskills",
            cmpSubCode: "componentmxskills",
            type: openType, //0 自动，1用户手动
          },
          callback: (res: any) => {
            console.log(res, "----handleSubscribehandleSubscribe");
            if (res && res.data && res.data.subscribeStatus == 1) {
              isSubscribe.value = true;
              // $toast.show("订阅成功", 2000);
            } else {
              isSubscribe.value = false;
              // $toast.show("订阅失败", 2000);
            }
          },
        });
      }
    },
    () => {
      // App外
      window.linkAppMed();
    }
  );
};

//  去授权按钮
const submitAuthClick = () => {
  appInfo.inApp(
    () => {
      // 东财App内
      if (hasAISQAuth.value) return;
      if (haslogin.value) {
        ctPopType.value = "authpost";
      } else {
        callLoginHandle();
      }
    },
    () => {
      // App外
      window.linkAppMed();
    }
  );
};
// 查询用户是否授权
const queryAuthMed = () => {
  let obj = {
    api: "/api/aifinancecommunity/queryAuth",
    success: (res: any) => {
      if (res && res.status == 0) {
        hasAISQAuth.value = res && res.data;
      }
    },
  };
  fetchData.doPost(obj);
};
// 居中弹窗回调
const handleCenterPop = (type: any = null) => {
  ctPopType.value = "";
  if (type == "authpost") {
    // 去授权
    submitAuthMed();
  } else if (type == "sleepConfim") {
  }
};
// 激活账户（恢复基础调用次数，有效期24h）
const accountActivate = () => {
  let obj = {
    api: "/skill/activate",
    success: (res: any) => {
      if (res && res.status == 0 && res.data) {
        getSleepStatus();
        ctPopType.value = "sleepConfim";
      }
    },
  };
  fetchData.doPost(obj);
};
// 授权
const submitAuthMed = () => {
  let obj = {
    api: "/api/aifinancecommunity/submitAuth",
    success: (res: any) => {
      if (res && res.status == 0) {
        // 刷新授权状态
        $toast.show("授权成功", 1500);
        queryAuthMed();
      }
    },
  };
  fetchData.doPost(obj);
};
// 查询是否订阅
const getSubscribeStatus = () => {
  appInfo.inApp(
    () => {
      // 在主包系App中
      callHybridHandle({
        moduleName: "Push", // 模块
        methodName: "emGetSubscribeStatus", // 方法名
        requestJson: {
          bizCode: "mxskills",
          cmpSubCode: "componentmxskills",
        },
        callback: (res: any) => {
          console.log(res.data, "----getSubscribeStatus");
          let resp = res && res.data;

          // 订阅开关是否展示
          if (resp.subscribeSwitch == 1 && resp.subscribeStatus != -1) {
            subscribeSwitch.value = true;
          } else {
            subscribeSwitch.value = false;
          }

          if (resp.subscribeStatus == 1) {
            isSubscribe.value = true;
          } else {
            isSubscribe.value = false;
          }

          if (resp.isAuto == 1 && haslogin.value) {
            handleSubscribe(0);
          }
        },
      });
    },
    () => {
      // 不在主包系App中
      subscribeSwitch.value = false;
    }
  );
};

const handleMessage = () => {
  appInfo.inApp(
    () => {
      // 东财App内
      if (appInfo.isIOS) {
        window.location.href =
          "eastmoney://page/emrn?id=messageCenter&page=MessagesList&bizCode=mxskills";
      } else {
        window.location.href =
          "dfcft://router/hybrid/react?id=messageCenter&page=MessagesList&&bizCode=mxskills";
      }
    },
    () => {
      // App外
      window.linkAppMed();
    }
  );
};

// 详情弹窗去授权
const detailToAuth = () => {
  // detailVisible.value = false;
  ctPopType.value = "authpost";
};
// 登录相关
/****************************** 处理登录态 ******************************/
const callLoginHandle = (callback?: any, invalidLogin?: any) => {
  // 已经登录
  if (haslogin.value && callback) {
    callback();
    return;
  }
  getLoginInfo(
    (res: any) => {
      //获取到用户信息
      console.log("已登录", res);
      if (typeof res === "string") {
        res = JSON.parse(res);
      }
      initUserInfo(res, callback);
    },
    () => {
      $loading.hide();
      if (invalidLogin) {
        return;
      }
      // 拉起通行证登录页
      performNativeLogin((res: any) => {
        // 登录成功后回调
        if (typeof res === "string") {
          res = JSON.parse(res);
        }
        initUserInfo(res, callback);
      });
    }
  );
};
const initUserInfo = (res: any, callback?: any) => {
  const _obj = {} as any;
  _obj["nickname"] = decodeURIComponent(
    decodeURIComponent(res["data"]["nickname"])
  );
  _obj["ct"] = res["data"]["ct"];
  _obj["ut"] = res["data"]["ut"];
  _obj["uid"] = res["data"]["uid"];
  _obj["hasSecurities"] = res["data"]["hasSecurities"];
  _obj["haslogin"] = true;
  const _userObj = Object.assign(userObj.value, _obj);
  _obj["userObj"] = _userObj;
  setUserInfo(_obj);

  if (callback) {
    callback();
  }
};
</script>

<style lang="scss" scoped>
.maintain_container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  padding-bottom: 2rem;
  .top_area {
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 7.5rem;
    height: 0.96rem;
    margin: 0 auto;
    border-bottom: 0.02rem solid rgba(0, 0, 0, 0.1);

    .top_logo {
      width: 4.38rem;
      height: 0.32rem;
      margin-left: 0.24rem;
      font-size: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .icon_message {
      margin-left: 0.3rem;
      position: relative;
      width: 0.4rem;
      height: 0.4rem;
      font-size: 0;
      img {
        width: 100%;
        height: 100%;
      }
      .meseeage_num {
        position: absolute;
        top: -0.14rem;
        right: -0.14rem;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 0.26rem;
        height: 0.26rem;
        background: #ff3849;
        border-radius: 1rem 1rem 1rem 0.04rem;
        font-size: 0.16rem;
        color: #ffffff;
      }
    }

    .sub_box {
      margin-left: 0.12rem;
      width: 1.8rem;
      height: 0.4rem;
      box-sizing: border-box;
      // background-color: red;
      display: flex;
      align-items: center;
      .sub_text {
        text-align: right;
        width: 1.16rem;
        height: 0.4rem;
        line-height: 0.4rem;
        font-size: 0.22rem;
        color: #333333;
      }
      .sub_icon {
        margin-left: 0.08rem;
        width: 0.64rem;
        height: 0.4rem;
        font-size: 0;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .ic_passwordbox {
    position: relative;
    width: 0.48rem;
    height: 0.48rem;
    padding: 0.24rem 0.27rem;
    font-size: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .top_title {
    margin-top: 0.26rem;
    margin-bottom: 0.2rem;
    width: 100%;
    text-align: center;

    .title_text {
      font-size: 0;
      img {
        width: 5.39rem;
        height: 0.61rem;
      }
    }
    .title_tips {
      width: 90%;
      margin: 0 auto;
      margin-top: 0.24rem;
      font-size: 0.28rem;
      color: #666666;
    }
  }

  .content_box {
    position: relative;
    box-sizing: border-box;
    width: 6.86rem;
    height: auto;
    padding: 0.32rem 0.24rem;
    margin-top: 0.24rem;
    border: 0.02rem solid rgba(0, 0, 0, 0.2);
    border-radius: 0.24rem;
    background: #ffffff;
    .content_top {
      display: flex;
      .left_icon {
        width: 0.48rem;
        height: 0.48rem;
        font-size: 0;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .mid_title {
        flex: 1;
        padding-left: 0.16rem;
        font-size: 0.32rem;
        font-weight: bold;
        color: #333333;
      }
      .right_more {
        position: relative;
        display: flex;
        align-items: center;
        width: 0.72rem;
        font-size: 0.24rem;
        color: #ff5500;
        .arrow {
          margin-left: 0.08rem;
          width: 0.12rem;
          height: 0.2rem;
          font-size: 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .content_intro {
      margin-top: 0.18rem;
      font-size: 0.26rem;
      color: #666666;
      word-break: break-all;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* 超出几行省略 */
      line-clamp: 2;
      overflow: hidden;
    }
    .content_tag {
      margin-top: 0.2rem;
      display: flex;
      .tag_item {
        margin-right: 0.16rem;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 0.44rem;
        padding-left: 0.12rem;
        padding-right: 0.12rem;
        background: #f8f8fa;
        border-radius: 0.08rem;
        font-size: 0.24rem;
        color: #333333;
      }
    }
    .combination_btn {
      margin-top: 0.16rem;
      display: inline-flex;
      align-items: center;
      height: 0.48rem;
      // width: fit-content;
      max-width: 100%;
      box-sizing: border-box;
      border: 0.02rem solid rgba(0, 0, 0, 0.1);
      border-radius: 0.24rem;
      padding-left: 0.2rem;
      padding-right: 0.2rem;
      .combination_left {
        font-size: 0.24rem;
        color: #666666;
        white-space: nowrap;
      }

      .combination_right {
        font-size: 0.24rem;
        white-space: nowrap;
        display: flex;
        align-items: center;
        .combination_name {
          color: #666666;
          font-size: 0.24rem;
          white-space: nowrap;
        }

        .text {
          margin-left: 0.04rem;
          font-size: 0.24rem;
          color: #ff5500;
        }

        .arrow_icon {
          margin-left: 0.1rem;
          width: 0.12rem;
          height: 0.2rem;
          font-size: 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .combination_tips {
      width: 100%;
      margin-top: 0.16rem;
      display: flex;
      align-items: center;

      font-size: 0.24rem;
      color: #ff6600;
      .ic_detail {
        margin-right: 0.08rem;
        width: 0.32rem;
        height: 0.32rem;
        font-size: 0;
        svg {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .bottom_tips {
    margin-top: 0.16rem;
    font-size: 0.24rem;
    color: #999999;
  }

  .bottom_fixed {
    position: fixed;
    box-sizing: border-box;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    padding-top: 0.2rem;
    width: 100%;
    height: 1.5rem;
    background: #ffffff;
    box-shadow: 0 0 0.16rem 0 rgba(0, 0, 0, 0.08);
    z-index: 5;
    .bottom_btn {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 6.86rem;
      height: 0.92rem;
      background: #ff5500;
      border-radius: 0.16rem;
      font-size: 0.32rem;
      font-weight: bold;
      color: #ffffff;

      .icon_book {
        margin-top: 0.04rem;
        margin-right: 0.16rem;
        width: 0.32rem;
        height: 0.32rem;
        font-size: 0;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .api_key_get_area {
    width: 6.86rem;
    min-height: 2.56rem;
    margin: 0 auto;
    background: #f8f8fa;
    border-radius: 0.24rem;

    .api_key_get_title {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #333;
      padding-top: 0.2rem;
      margin-bottom: 0.2rem;

      .api_key_get_icon {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.04rem;
      }
      span {
        font-size: 0.26rem;
        color: #333333;
      }
      .api_key_get_limit {
        color: #ff6600;
        font-size: 0.26rem;
      }
    }

    .api_key_get_progress_bar {
      width: 6.06rem;
      height: 0.16rem;
      margin: 0 auto;
      background: #e1e1e8;
      border-radius: 0.18rem;
      margin-bottom: 0.32rem;
      font-size: 0;
      overflow: hidden;

      .api_key_get_progress_inner {
        height: 100%;
        background: #ff6600;
        border-radius: 0.18rem;
        transition: width 0.3s;
      }
    }

    .api_key_get_btn_wrap {
      position: relative;
      display: flex;
      justify-content: center;
      width: 3.88rem;
      height: 1rem;
      margin: 0 auto;
      .api_key_get_btn {
        box-sizing: border-box;
        width: 3.88rem;
        height: 1rem;
        padding-top: 0.52rem;
        background: url(./images/receive_btn.png) no-repeat;
        background-size: 100% 100%;
        border: none;

        .api_key_get_btn_percent {
          transform: scale(0.916);
          transform-origin: center center;
          text-align: center;
          font-size: 0.24rem;
          color: #ffeb00;
        }
      }
      .pic_qzbox {
        position: absolute;
        right: 0;
        top: 0.28rem;
        width: 1rem;
        height: 1rem;
        animation: finger_move_updown 2s infinite;
        img {
          width: 1rem;
          height: 1rem;
        }
      }

      @keyframes finger_move_updown {
        0% {
          right: 0;
          top: 0.28rem;
        }
        25% {
          right: -0.24rem;
          top: 0.36rem;
        }
        50% {
          right: 0;
          top: 0.28rem;
        }
        75% {
          right: -0.24rem;
          top: 0.36rem;
        }
        100% {
          right: 0;
          top: 0.28rem;
        }
      }
    }
  }
  .jc_box {
    width: 6.86rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.32rem 0.24rem;
    background: #ffffff;
    border: 0.01rem solid rgba(0, 0, 0, 0.2);
    border-radius: 0.24rem;
    .title_box {
      font-size: 0.32rem;
      font-weight: bold;
      color: #333333;
      line-height: 0.44rem;
      width: 100%;
    }
    .sub_box {
      margin-top: 0.108em;
      font-size: 0.24rem;
      color: #666666;
      width: 100%;
      text-align: justify;
      span {
        color: red;
      }
    }
    .copy_box {
      width: 6.38rem;
      height: auto;
      box-sizing: border-box;
      padding: 0.16rem 0.24rem;
      display: flex;
      align-items: center;
      background: #f8f8fa;
      border-radius: 0.16rem;
      margin: 0.16rem auto 0;
      .copy_text {
        flex: 1;
        font-size: 0.24rem;
        color: #333333;
        letter-spacing: -0.01rem;
        overflow-wrap: anywhere;
        word-break: break-all;
      }
      .icon_box {
        flex-shrink: 0;
        width: 0.28rem;
        height: 0.28rem;
        font-size: 0;
        margin-left: 0.24rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .copy_btn {
      width: 4.4rem;
      height: 0.72rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #ff5500;
      border-radius: 0.36rem;
      box-sizing: border-box;
      margin: 0.32rem auto 0;
      font-size: 0.26rem;
      color: #ff5500;
      font-weight: bold;
    }
  }
}
.keys_box_only {
  margin-top: 0.24rem;
  display: flex;
  width: 6.86rem;
  justify-content: space-between;
  .key_btn {
    position: relative;
    display: flex;
    align-items: center;

    width: 3.36rem;
    height: 1.12rem;
    background: #f8f8fa;
    border-radius: 0.24rem;

    .ic_key {
      margin-left: 0.16rem;
      width: 0.4rem;
      height: 0.4rem;
      font-size: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .mid_text {
      width: 2.32rem;
      // background-color: red;
      margin-left: 0.16rem;
      .text1 {
        font-weight: bold;
        font-size: 0.26rem;
        color: #333333;
      }
      .text2 {
        font-size: 0.22rem;
        color: #999999;
      }
    }
    .ic_arrow {
      // margin-left: 0.1rem;
      width: 0.12rem;
      height: 0.2rem;
      font-size: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .key_tag {
      position: absolute;
      top: -0.18rem;
      right: 0;
      width: 1.6rem;
      height: 0.3rem;
      background-color: rgb(235, 60, 60);
      border-top-left-radius: 0.3rem;
      border-top-right-radius: 0.3rem;
      border-bottom-right-radius: 0.3rem;
      div {
        position: relative;
        left: -20%;
        width: 140%;
        line-height: 0.3rem;
        text-align: center;
        transform-origin: center center;
        font-size: 0.24rem;
        color: #fff;
        transform: scale(0.72);
      }
    }
  }
  .key_vip {
    background: url("./images/key_bgc.png") no-repeat;
    background-size: 100% 100%;
  }
  .key_vip2 {
    background: url("./images/key_bgc2.png") no-repeat;
    background-size: 100% 100%;
  }
}
</style>
